import Joi from 'joi';

export const FORM_FIELD_KEYS = {
  EMAIL: 'email',
  OTP: 'otp',
}

const jcrEmailRegex = /^[A-Za-z0-9._%+-]+@jaspercolin.com$/

export const operationsEmailSchema = Joi.object({
  [FORM_FIELD_KEYS.EMAIL]: Joi.string().label('E-Mail').email({ tlds: { allow: false } }).required().trim().regex(jcrEmailRegex).messages({
    "string.pattern.base": "\"E-Mail\" must be of Jasper Colin Research"
  }),
})

export const operationsOtpSchema = Joi.object({
  [FORM_FIELD_KEYS.OTP]: Joi.string().label('OTP').alphanum().length(6).required().trim(),
})